var React = require('react');

function Send (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.6592 10.1595L4.57629 11.1733C4.43382 11.197 4.31487 11.2951 4.26435 11.4304L2.16605 17.0498C1.9652 17.5663 2.50589 18.059 3.00154 17.8112L17.54 10.542C17.9865 10.3187 17.9865 9.68157 17.54 9.45833L3.00154 2.1891C2.50589 1.94127 1.9652 2.434 2.16605 2.95047L4.26435 8.5699C4.31487 8.70521 4.43382 8.80324 4.57629 8.82698L10.6592 9.8408C10.7472 9.85547 10.8067 9.9387 10.792 10.0267C10.7806 10.0948 10.7273 10.1481 10.6592 10.1595Z","fill":"#201c50"}));
}

Send.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Send;

Send.default = Send;
